module.exports = __webpack_public_path__ + "img/keyBuckle_7.035c20a3.jpg";